<template>
  <div class="flex items-center gap-2">
    <span v-if="!isBlocks">{{ $t('components.workflow.if') }}</span>

    <Dropdown
      v-model="model"
      :options="mappedOperators"
      v-bind="dropdownConfig" 
      class="w-14 h-6 rounded-md"
      :class="{
        'bg-white': !isBlocks && !disabled,
        'bg-main text-white-text': isBlocks && !disabled,
        'bg-primary text-base-content-300': isBlocks && disabled
      }"
    >
      <template #before>
        {{ displayedName }}
      </template>
      <template #caret>
        <font-awesome-icon v-if="!isBlocks" icon="angle-down" />
        <font-awesome-icon v-else icon="angle-up" class="text-white-text" />
      </template>
    </Dropdown>

    <div v-if="!isBlocks" class="flex items-center gap-2">
      <span>{{ $t('components.workflow.of_the_following_is') }} </span>

      <Dropdown
        v-model="additionalOperator"
        :options="additionalOptions"
        v-bind="dropdownConfig"
        class="w-16 h-6 rounded-md"
        :class="{
          'bg-white': !isBlocks && !disabled,
          'bg-main text-white-text': isBlocks && !disabled,
        }"
      >
        <template #before>
          {{ displayedAdditionalName }}
        </template>
        <template #caret>
          <font-awesome-icon icon="angle-down" />
        </template>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import Dropdown from "@shared/components/dropdown-base";
import { clone } from "lodash";
import { OPERATORS_LIST } from "../constants";

export default {
  name: "ConditionOperator",

  components: {
    Dropdown,
  },

  props: {
    operator: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isBlocks: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    model: {
      get() {
        return { id: this.operator.main, name: " " };
      },
      set(value) {
        this.$emit("select", { key: "main", value });
      }
    },

    displayedName() {
      return this.isBlocks ? this.item.id.toUpperCase() : this.item.name;
    },

    item() {
      return this.operators.find(el => el.id === this.operator.main)
    },

    mappedOperators() {
      if (!this.isBlocks) return this.operators;
      return this.operators.map(el => ({
        id: el.id,
        name: el.id.toUpperCase(),
      }));
    },

    operators() {
      return clone(OPERATORS_LIST);
    },

    additionalOperator: {
      get() {
        return { id: this.operator.additional , name: " " };
      },
      set(value) {
        this.$emit("select", { key: "additional", value });
      }
    },

    displayedAdditionalName() {
      return this.additionalOptions.find(el => el.id === this.operator.additional)?.name
    },

    additionalOptions() {
      return ["true", "false"].map(el => ({
        id: el,
        name: el,
      }));
    },

    dropdownConfig() {
      return {
        config: { trackBy: "id", label: "name" },
        disabled: this.disabled,
      };
    },
  },
}
</script>
